import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

// Function to initialize the base URL
export const fetchBaseURLPromise = async (): Promise<string> => {
  let baseUrl = '';
  if (process.env.REACT_APP_ENV !== 'ephemeral') {
    baseUrl = process.env.REACT_APP_API_BASE_URL || '';
  } else {
    const response = await fetch('/base.json');
    const data = await response.json();
    baseUrl = data.apiBaseUrl;
  }

  axios.defaults.baseURL = baseUrl;
  return baseUrl;
};

// Initialize the promise immediately
const baseUrlPromise: Promise<string> = fetchBaseURLPromise();

// Create axios instance after base URL is loaded
let axiosInstance: AxiosInstance;

async function getAxiosInstance() {
  const baseURL = await baseUrlPromise;
  if (!axiosInstance) {
    axiosInstance = axios.create({
      baseURL,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
  return axiosInstance;
}

export async function updateAxiosSessionToken(sessionToken: string) {
  const instance = await getAxiosInstance();
  instance.defaults.headers['Authorization'] = `Bearer ${sessionToken}`;
}

// Modified GET request to ensure axios is initialized
async function get<T>(endpoint: string, config?: AxiosRequestConfig<any>): Promise<T> {
  const instance = await getAxiosInstance();
  const response: AxiosResponse<T> = await instance.get(endpoint, config);
  return response.data;
}

// Modified POST request to ensure axios is initialized
async function post<T>(
  endpoint: string,
  data?: AxiosRequestConfig['data'],
  config?: AxiosRequestConfig<any>
): Promise<T> {
  const instance = await getAxiosInstance();
  const response: AxiosResponse<T> = await instance.post(endpoint, data, config);
  return response.data;
}

export { get, post };
